import classNames from 'classnames'
import * as React from 'react'
import './CoverPhoto.scss'
import { ICoverPhotoOverlayProps } from './CoverPhotoOverlay'

export interface ICoverPhotoProps {
  className?: string
  children?: React.ReactElement<ICoverPhotoOverlayProps>
  photoUrl: string
  style?: React.CSSProperties
}

export class CoverPhoto extends React.PureComponent<ICoverPhotoProps> {
  public render() {
    const coverPhotoStyles: React.CSSProperties = this.props.style || {}
    coverPhotoStyles.backgroundImage = `url('${this.props.photoUrl}')`

    return (
      <div
        className={classNames('cover-photo', this.props.className)}
        style={coverPhotoStyles}
      >
        {this.props.children}
      </div>
    )
  }
}
